{
  "userSettings": {
    "title": "Beállításaim",
    "description": "Személyes profil és beállítások kezelése",
    "tabs": {
      "profile": "Profil",
      "preferences": "Beállítások",
      "security": "Biztonság"
    },
    "profile": {
      "firstName": "Keresztnév",
      "lastName": "Vezetéknév",
      "email": "E-mail",
      "emailHelper": "Lépjen kapcsolatba szervezeti menedzserével az e-mail cím módosításához",
      "role": "Beosztás",
      "roleHelper": "Lépjen kapcsolatba szervezeti menedzserével a beosztása módosításához",
      "department": "Osztály",
      "departmentHelper": "Lépjen kapcsolatba szervezeti menedzserével az osztály módosításához",
      "status": "Fiók státusz",
      "organizationInfo": "Szervezeti információ",
      "updateSuccess": "Profil sikeresen frissítve",
      "updateError": "Nem sikerült a profil frissítése"
    },
    "preferences": {
      "language": "Nyelv",
      "languageHelper": "Válassza ki a felület preferált nyelvét"
    },
    "security": {
      "currentPassword": "Jelenlegi jelszó",
      "newPassword": "Új jelszó",
      "confirmPassword": "Új jelszó megerősítése",
      "changePassword": "Jelszó módosítása",
      "passwordSuccess": "Jelszó sikeresen módosítva",
      "passwordError": "Nem sikerült a jelszó módosítása",
      "invalidCurrentPassword": "A jelenlegi jelszó helytelen",
      "passwordRequirements": "Jelszókövetelmények",
      "minLength": "Legalább 8 karakter hosszú",
      "requireLowercase": "Legalább egy kisbetű (a-z)",
      "requireUppercase": "Legalább egy nagybetű (A-Z)",
      "requireNumber": "Legalább egy szám (0-9)",
      "twoFactorTitle": "Kétfaktoros hitelesítés (2FA)",
      "twoFactorDescription": "Védje fiókját egy hitelesítő alkalmazás által generált egyszeri kóddal.",
      "twoFactorEnabled": "A kétfaktoros hitelesítés aktív",
      "setupTwoFactor": "2FA beállítása",
      "scanQrCode": "Olvassa be ezt a QR-kódot a hitelesítő alkalmazással, majd írja be a 6 számjegyű kódot.",
      "manualSecret": "Nem tudja beolvasni? Titkos kulcs megjelenítése kézi bevitelhez",
      "codeLabel": "6 számjegyű kód",
      "verifyCode": "Kód ellenőrzése",
      "removeTwoFactor": "2FA eltávolítása",
      "removeTwoFactorConfirm": "Fiókja a bejelentkezéskor többé nem kér egyszeri kódot. Biztos benne?",
      "twoFactorSetupSuccess": "Kétfaktoros hitelesítés bekapcsolva",
      "twoFactorSetupError": "A kétfaktoros hitelesítés beállítása sikertelen",
      "twoFactorRemoveSuccess": "Kétfaktoros hitelesítés eltávolítva",
      "twoFactorRemoveError": "A kétfaktoros hitelesítés eltávolítása sikertelen",
      "ssoManagedTitle": "A szervezete kezeli",
      "ssoManagedDescription": "Jelszavát és kétfaktoros hitelesítését a(z) {{idpName}} kezeli.",
      "ssoManagedFallbackIdp": "szervezete identitásszolgáltatója",
      "passwordUnavailable": "A jelszó módosítása még nem érhető el a fiókjához. Jelentkezzen be egyszer egyszeri bejelentkezéssel (SSO), vagy forduljon a rendszergazdához.",
      "noPasswordSet": "Ehhez a fiókhoz nincs jelszó beállítva, így nincs módosítható jelszó.",
      "statusError": "A biztonsági beállítások betöltése nem sikerült.",
      "passkeysTitle": "Passkey-k",
      "passkeysDescription": "Jelentkezzen be jelszó nélkül Face ID, Touch ID vagy hardveres biztonsági kulcs segítségével.",
      "addPasskey": "Passkey hozzáadása",
      "unnamedPasskey": "Passkey",
      "removePasskey": "Passkey eltávolítása",
      "removePasskeyConfirm": "Ezzel a passkey-jel többé nem lehet bejelentkezni. Biztos benne?",
      "passkeyRemoveSuccess": "Passkey eltávolítva",
      "passkeyRemoveError": "A passkey eltávolítása nem sikerült",
      "reauthenticate": "Bejelentkezés megerősítése",
      "passkeyLinkError": "A passkey beállításának elindítása nem sikerült",
      "passkeyPopupBlocked": "A böngészője letiltotta a passkey beállításához szükséges lapot. Kérjük, engedélyezze a felugró ablakokat ezen az oldalon, majd próbálja meg újra.",
      "stepUpTitle": "Friss bejelentkezés szükséges",
      "stepUpDescription": "Az Ön biztonsága érdekében a bejelentkezési beállítások módosításához friss bejelentkezés szükséges. Átirányítjuk a bejelentkezés megerősítéséhez, majd visszatér erre az oldalra.",
      "stepUpPasskeyDescription": "Az Ön biztonsága érdekében passkey hozzáadásához friss bejelentkezés szükséges. A bejelentkezés megerősítése után kattintson újra a „Passkey hozzáadása” gombra.",
      "stepUpSignInAgain": "Az Ön biztonsága érdekében ehhez a módosításhoz friss bejelentkezés szükséges. Kérjük, jelentkezzen ki, majd jelentkezzen be újra, és próbálja meg ismét."
    }
  },
  "adminSettings": {
    "tenant": {
      "tabUsers": "Felhasználók",
      "tabSettings": "Beállítások",
      "slug": "Azonosító: {{slug}}",
      "addUser": "Felhasználó hozzáadása",
      "columnName": "Név",
      "columnEmail": "E-mail",
      "columnUserTypes": "Felhasználótípusok",
      "columnStatus": "Státusz",
      "columnClassification": "Besorolás",
      "sendInvitationAction": "Meghívó küldése",
      "resendInvitationAction": "Meghívó újraküldése",
      "copyActivationLinkAction": "Aktiválási link másolása",
      "copyActivationLinkSuccess": "Aktiválási link a vágólapra másolva",
      "copyActivationLinkFailed": "Az aktiválási link létrehozása sikertelen",
      "copyActivationLinkManual": "Másolja ki ezt az aktiválási linket kézzel",
      "resetSignInFailed": "Nem sikerült a bejelentkezés alaphelyzetbe állítása",
      "deleteUserTitle": "Felhasználó törlése",
      "deleteUserDescription": "Biztosan törölni szeretné ezt a felhasználót? Ez a művelet nem vonható vissza.",
      "deleteUserSuccess": "Felhasználó sikeresen törölve",
      "deleteUserFailed": "Nem sikerült a felhasználó törlése",
      "sendInvitationSuccess": "Meghívó sikeresen elküldve",
      "sendInvitationFailed": "Nem sikerült a meghívó küldése",
      "createdButInvitationFailed": "A felhasználó létrejött, de a meghívó küldése sikertelen volt — használja a \"Meghívó újraküldése\" lehetőséget",
      "externalOrgRequired": "A külső szervezet megadása kötelező külső felhasználóknál",
      "aiTitle": "AI funkciók",
      "aiDescription": "AI funkciók elérhetőségének szabályozása ehhez a bérlőhöz.",
      "enableAILabel": "AI engedélyezése",
      "enableAIDescription": "Főkapcsoló a bérlő összes AI-funkciójához, például Bliksy, lépésösszefoglaló és diktálás. Ügyfél- és partnerbérlőkre egyaránt vonatkozik.",
      "saved": "Bérlő beállítások mentve.",
      "saveFailed": "Nem sikerült a bérlő beállítások mentése.",
      "tabApps": "Alkalmazások",
      "tabUsage": "Használat",
      "appsDescription": "Kezelje, mely alkalmazásokkal rendelkezik ez a bérlő.",
      "addAppSuccess": "Alkalmazás sikeresen hozzáadva.",
      "addAppFailed": "Nem sikerült az alkalmazás hozzáadása.",
      "removeAppSuccess": "Alkalmazás sikeresen eltávolítva.",
      "removeAppFailed": "Nem sikerült az alkalmazás eltávolítása.",
      "addApp": "Alkalmazás hozzáadása",
      "addAppNoCandidates": "Nincs több hozzáadható alkalmazás.",
      "noAppsAdded": "Ehhez a bérlőhöz még nem adtak hozzá alkalmazást.",
      "appAllowed": "Használhatja ezt az alkalmazást",
      "appAllowedSaved": "Jogosultság mentve.",
      "appAllowedSaveFailed": "Nem sikerült a jogosultság mentése.",
      "appSeats": "Helyek",
      "appSeatLimit": "Helykorlát",
      "seatLimitSaved": "Helykorlát mentve.",
      "seatLimitSaveFailed": "Nem sikerült menteni a helykorlátot.",
      "removeAppTitle": "Alkalmazás eltávolítása",
      "removeAppConfirm": "Az alkalmazás eltávolítása elveti a bérlőspecifikus konfigurációját, és felszabadítja az összes kiosztott helyet. Az ismételt hozzáadás nem állítja vissza őket.",
      "removeApp": "Eltávolítás a bérlőtől",
      "appConfig": "Konfiguráció",
      "appConfigPlannerEnabled": "Intézkedés-projekttervező",
      "appConfigSalesPartnerCompanyId": "A partner HubSpot-cége",
      "appConfigSalesPartnerCompanyIdHint": "A partner csak az e cég munkatársai által hozott leadeket látja. A tenanton karbantartva, nem itt.",
      "appConfigSalesPartnerCompanyIdMissing": "Ehhez a tenanthoz nincs HubSpot-cég kapcsolva: a partner nem lát leadeket és nem is jelenthet be. Az Általános fülön állítható be.",
      "appConfigUnreadable": "A mentett konfiguráció nem olvasható; a mentés felülírja.",
      "appConfigure": "Konfigurálás",
      "appConfigTitle": "Alkalmazás konfigurációja",
      "appConfigUnreadableDialog": "Létezik mentett konfiguráció, de a jelenlegi sémával nem olvasható. Itt nem jelenik meg, és a mentés felülírja.",
      "appConfigNorms": "Normák",
      "appConfigNormsPlaceholder": "Válasszon normákat",
      "appConfigRequestAllowance": "Requestek szerződéses évenként",
      "appConfigContractAnchor": "Szerződés kezdete",
      "appConfigContractAnchorPick": "Válasszon dátumot",
      "appConfigContractAnchorPopup": "Szerződéskezdet naptára",
      "appConfigContractAnchorFuture": "A szerződés kezdete nem lehet a jövőben.",
      "appConfigSaved": "A konfiguráció mentve.",
      "appConfigSaveFailed": "A konfiguráció mentése nem sikerült.",
      "provisioningTitle": "Munkaterületek létrehozása másoknak",
      "provisioningDescription": "Milyen típusú munkaterületeket hozhat létre és kezelhet ez a partner mások számára, pl. az értékesítési alkalmazásból. Kijelölés nélkül egyet sem hozhat létre."
    },
    "globalAi": {
      "title": "AI modell beállítások",
      "description": "Az összes bérlő által használt AI modellek konfigurálása.",
      "highModelLabel": "Magas szintű modell",
      "highModelDescription": "Összetett feladatokhoz használt AI modell (Bliksy ügynök, Omniscient).",
      "lowModelLabel": "Alacsony szintű modell",
      "lowModelDescription": "Egyszerű feladatokhoz használt AI modell (lépés összefoglalók, Bliksy alfeladatok).",
      "transcriptionModelLabel": "Átírási modell",
      "transcriptionModelDescription": "Hang-szöveg átíráshoz használt modell.",
      "saved": "AI modell beállítások mentve.",
      "saveFailed": "Nem sikerült az AI modell beállítások mentése.",
      "featureOverride": {
        "title": "Funkció-szintű felülírások",
        "description": "Opcionálisan rögzíthetsz egy funkciót egy konkrét modellhez vagy szinthez. Alapértelmezés szerint minden funkció a hozzárendelt szintet követi.",
        "tier": {
          "high": "Magas szint",
          "low": "Alacsony szint",
          "decision": "Döntési szint"
        },
        "bliksy-chat": {
          "label": "Bliksy csevegés",
          "description": "Interaktív felvételi asszisztens ügynök."
        },
        "bliksy-modify-subagent": {
          "label": "Bliksy módosító alügynök",
          "description": "A Bliksyn belül strukturált lépés-módosításokat alkalmazó alügynök."
        },
        "step-summary": {
          "label": "Lépés összefoglaló",
          "description": "Lépésneveket és leírásokat generál a felvétel befejezése után."
        },
        "chat-title": {
          "label": "Csevegéscím generálása",
          "description": "Rövid címeket készít a csevegésekhez."
        },
        "chat-summarizer": {
          "label": "Beszélgetés összefoglalása",
          "description": "Hosszú beszélgetéseket folyamatos összefoglalóvá tömörít."
        },
        "decision-eval-judge": {
          "label": "Döntési bíráló (kiértékelések)",
          "description": "Fokozatos kérdésekkel pontozza a kiértékelési futtatásokat."
        }
      },
      "appOverride": {
        "title": "Alkalmazásmodellek"
      },
      "reasoning": {
        "label": "Érvelési erőfeszítés",
        "effort": {
          "none": "Kikapcsolva",
          "low": "Alacsony",
          "medium": "Közepes",
          "high": "Magas",
          "xhigh": "Nagyon magas",
          "max": "Maximális"
        }
      }
    },
    "superAdmin": {
      "title": "Felhasználókezelés",
      "description": "Szuperadmin felhasználók kezelése a rendszerben",
      "inviteUser": "Felhasználó meghívása",
      "errorLoadingUsers": "Hiba a felhasználók betöltésekor",
      "columnEmail": "E-mail",
      "columnFirstName": "Keresztnév",
      "columnLastName": "Vezetéknév",
      "columnStatus": "Státusz",
      "columnInvited": "Meghívva",
      "columnActivated": "Aktiválva",
      "inviteTitle": "Szuperadmin felhasználó meghívása",
      "inviteDescription": "Meghívó küldése új szuperadmin felhasználónak. Az illető e-mailt kap a fiók aktiválásának utasításaival.",
      "inviteSend": "Meghívó küldése",
      "firstNameRequired": "A keresztnév megadása kötelező",
      "lastNameRequired": "A vezetéknév megadása kötelező",
      "emailRequired": "Az e-mail cím megadása kötelező",
      "emailInvalid": "Érvénytelen e-mail cím",
      "role": "Szerepkör",
      "roles": {
        "platform_admin": "Platform-adminisztráció",
        "platform_support": "Támogatás"
      },
      "roleHint": {
        "platform_admin": "Mindent megtehet: katalógus, felhasználók, beállítások, törlés.",
        "platform_support": "Olvassa a fiókokat, a munkaterületek listáját és a naplókat — semmit nem módosít."
      },
      "roleNone": "Nincs szerepkör",
      "noAccessTitle": "Nincs engedélyezett terület",
      "noAccessBody": "Ez a fiók a platformhoz tartozik, de nincs szerepköre. Platform-adminisztrátor rendelhet hozzá egyet a felhasználókezelésben.",
      "rolePlaceholder": "Válasszon szerepkört",
      "roleRequired": "Kérjük, válasszon szerepkört.",
      "changeRole": "Szerepkör módosítása",
      "changeRoleTitle": "Szerepkör módosítása",
      "changeRoleDescription": "Mit tehet {{name}} a platformon.",
      "changeRoleSave": "Mentés"
    }
  }
}
